import { commonService } from './commonService';

export const productDesignAndDevelopment = {
  ...commonService,
  name: 'Product Designand Development',
  serviceType: [
    'Web Design',
    'Web Development',
    'Mobile Development',
    'Custom Software Development',
    'Security and Quality Assurance',
    'Infrastructure Architecture',
    'Tech Stack Consulting',
    'E-commerce website',
    'Customer portal',
    'SaaS platform',
  ],
  description:
    'Boldare’s dedicated development teams build custom web and mobile apps with a focus on speed to market. We are able to deliver your digital product MVP in as little as 4-6 weeks employing the lean startup approach and agile software development.',
};
